import React from 'react';
import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';
import { Button } from 'reactstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cn from 'classnames';
import { Icon } from 'react-icons-kit';
import { image } from 'react-icons-kit/fa/image';

import galleryStyles from 'react-image-gallery/styles/css/image-gallery.css';
import { useFullscreenGallery } from 'components/OfferEndpage/FullscreenGallery';
import s from './Gallery.css';

import thumbnail from '../../ThumborImage/thumbor';

const renderFullscreenButton = onClick => (
  <Button
    color="link"
    type="button"
    className={cn(s.fullscreen_button)}
    onClick={onClick}
  >
    <Icon icon={image} /> Фотогалерея
  </Button>
);

const renderItem = ({ item, onClick }) => (
  <div className="image-gallery-image">
    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
    <div
      role="button"
      tabIndex={0}
      className={s.original}
      style={{ backgroundImage: `url(${item.original})` }}
      onClick={onClick}
    />
  </div>
);

renderItem.propTypes = {
  item: PropTypes.shape().isRequired,
  onClick: PropTypes.func.isRequired,
};

const renderThumbInner = item => (
  <div className="image-gallery-thumbnail-inner">
    <div
      className={s.thumbnail}
      style={{ backgroundImage: `url(${item.thumbnail})` }}
    />
  </div>
);

const Gallery = props => {
  const images = props.images.map(({ url, ...rest }, index) => ({
    ...rest,
    anchor: `image_${index}`,
    original: url,
    thumbnail: thumbnail(url, 100, 0),
  }));

  const [
    FullscreenGallery,
    { show, setShow: setShowFullscreenGallery, setActiveAnchor },
  ] = useFullscreenGallery(false);

  return (
    <>
      <FullscreenGallery images={images} />
      <ImageGallery
        items={images}
        slideInterval={2000}
        showPlayButton={false}
        renderItem={item =>
          renderItem({
            item,
            onClick: () => {
              setShowFullscreenGallery(true);
              setActiveAnchor(item);
            },
          })
        }
        renderThumbInner={renderThumbInner}
        lazyLoad
        loading="lazy"
        thumbnailLoading="lazy"
        renderFullscreenButton={() =>
          renderFullscreenButton(() => setShowFullscreenGallery(true), show)
        }
      />
    </>
  );
};

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default withStyles(galleryStyles, s)(Gallery);
